import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { MobileNavBarTab } from "./mobile-nav-bar-tab";

export const MobileNavBarTabs = ({ handleClick }) => {
  const { isAuthenticated } = useAuth0();

  return (
    <div className="mobile-nav-bar__tabs">
      <MobileNavBarTab
        path="/public/leaderboard"
        label="Leaderboard"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/public/auction"
        label="Auction List"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/auction-results"
        label="Auction Results"
        handleClick={handleClick}
      />
      <MobileNavBarTab
        path="/profile"
        label="Profile"
        handleClick={handleClick}
      />
      {isAuthenticated && (
        <>
          <MobileNavBarTab
            path="/protected"
            label="Protected"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin"
            label="Admin"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/sitevariables"
            label="Site Variables"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/updateweek"
            label="Update Week"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/admin/team-admin"
            label="Team Admin"
            handleClick={handleClick}
          />
          <MobileNavBarTab
            path="/score-breakdown"
            label="Score Breakdown"
            handleClick={handleClick}
          />
        </>
      )}
    </div>
  );
};
